{
  "removeButtonLabel": "削除",
  "removeDescription": "タグを削除するには、Delete キーを押します。"
}
